import { render, staticRenderFns } from "./StoreCorporationDetail.vue?vue&type=template&id=1e1f3343&scoped=true&"
import script from "./StoreCorporationDetail.vue?vue&type=script&lang=js&"
export * from "./StoreCorporationDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoreCorporationDetail.vue?vue&type=style&index=0&id=1e1f3343&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1f3343",
  null
  
)

export default component.exports